import React from 'react';
import Circle from '@mui/icons-material/Circle'; // Make sure you're using the correct icon library

const paleColors = {
  success: '#90ee90',  // Pale Green
  pending: '#FFDAB9',  // Pale Yellow
  error: '#ffcccb',    // Pale Red
};

const brightColors = {
  success: '#6ACE7F',
  pending: '#F79900',
  error: "#f40000",
};

// Single traffic light
const TrafficLight = ({ status }) => {
  const normalizedStatus = status.toLowerCase();
  
  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      margin: '2px',
      border: '2px solid gray',
      padding: '4px', // Adjusted padding with top-bottom and left-right
      borderRadius: '25px',
      height: '15px', // Adjust this to control overall height
      justifyContent: 'space-between', // Ensures even spacing
    }}>
      <Circle
        style={{
          color: normalizedStatus === 'error' ? brightColors.error : paleColors.error,
          fontSize: 15, // Adjust the font size to make the circles fit better
          border: normalizedStatus === 'error' ? '1.5px solid black' : 'none',
          borderRadius: '50%',
          marginRight: '4px',
        }}
      />
      <Circle
        style={{
          color: normalizedStatus === 'pending' ? brightColors.pending : paleColors.pending,
          fontSize: 15, // Adjust the font size to make the circles fit better
          border: normalizedStatus === 'pending' ? '1.5px solid black' : 'none',
          borderRadius: '50%',
          marginRight: '4px',
        }}
      />
      <Circle
        style={{
          color: normalizedStatus === 'success' ? brightColors.success : paleColors.success,
          fontSize: 15, // Adjust the font size to make the circles fit better
          border: normalizedStatus === 'success' ? '1.5px solid black' : 'none',
          borderRadius: '50%',
        }}
      />
    </div>
  );
};

// Group of traffic lights
const TrafficLightGroup = ({ statuses, direction = "row" }) => (
  <div style={{ display: 'flex', flexDirection: direction, gap: 8 }}>
    {statuses.map((status, idx) => (
      <TrafficLight key={idx} status={status} />
    ))}
  </div>
);

export { TrafficLightGroup };
export default TrafficLight;